import { Box, Typography } from '@mui/material'
import { MOBILE_MQ, mobileBodyTextSx } from '../../theme/mobileLayout'
import FigmaIconFrame from '../common/FigmaIconFrame'

const bodySx = {
  ...mobileBodyTextSx,
  fontSize: { xs: 16, sm: 22, md: 24 },
}

const headingSx = {
  fontSize: { xs: 22, sm: 30, md: 30 },
  lineHeight: 'normal',
  fontWeight: 400,
  color: '#111',
}

const listSx = {
  m: 0,
  pl: '36px',
  listStyleType: 'disc',
  listStylePosition: 'outside',
  fontSize: { xs: 16, sm: 22, md: 24 },
  lineHeight: 'normal',
  fontWeight: 400,
  color: '#111',
  width: '100%',
  '& li': {
    mb: 0,
    display: 'list-item',
  },
}

function EventListSection({ heading, items }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', width: '100%' }}>
      <Typography component="h2" sx={headingSx}>
        {heading}
      </Typography>
      <Box component="ul" sx={listSx}>
        {items.map((item) => (
          <Box component="li" key={item}>
            {item}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default function EventActivityCard({ title, description, icon, iconBgColor }) {
  return (
    <Box
      sx={{
        bgcolor: '#fffefa',
        borderRadius: '20px',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        p: '24px',
        width: '100%',
        boxSizing: 'border-box',
        [MOBILE_MQ]: { width: '100%' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '20px',
          alignItems: 'flex-start',
          [MOBILE_MQ]: { flexDirection: 'column' },
        }}
      >
        <FigmaIconFrame src={icon} bgColor={iconBgColor} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: 0 }}>
          <Typography sx={{ fontSize: { xs: 20, md: 24 }, lineHeight: 'normal', color: '#111' }}>
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, md: 18 },
              lineHeight: 'normal',
              color: 'rgba(17,17,17,0.6)',
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export function EventDetailBody({
  intro,
  highlights,
  participants,
  learningOutcomes,
  activities,
  whyAttend,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
        width: '100%',
        [MOBILE_MQ]: { gap: '32px' },
      }}
    >
      <Typography sx={bodySx}>{intro}</Typography>

      <EventListSection heading="Event Highlights" items={highlights} />
      <EventListSection heading="Who Can Participate?" items={participants} />
      <EventListSection heading="Key Learning Outcomes" items={learningOutcomes} />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <Typography component="h2" sx={headingSx}>
          Event Activities
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
            gap: '24px',
            width: '100%',
            [MOBILE_MQ]: {
              gridTemplateColumns: '1fr',
              gap: '16px',
            },
          }}
        >
          {activities.map((activity) => (
            <EventActivityCard key={activity.title} {...activity} />
          ))}
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <Typography component="h2" sx={headingSx}>
          Why Attend?
        </Typography>
        <Typography sx={bodySx}>{whyAttend}</Typography>
      </Box>
    </Box>
  )
}
